"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMoveWidgetToNewSectionDropHandler = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../model");
function useMoveWidgetToNewSectionDropHandler(newSectionIndex) {
    var dispatch = model_1.useDashboardDispatch();
    return react_1.useCallback(function (item) {
        return dispatch(model_1.moveSectionItemToNewSectionAndRemoveOriginalSectionIfEmpty(item.sectionIndex, item.itemIndex, newSectionIndex));
    }, [dispatch, newSectionIndex]);
}
exports.useMoveWidgetToNewSectionDropHandler = useMoveWidgetToNewSectionDropHandler;
//# sourceMappingURL=useMoveWidgetToNewSectionDropHandler.js.map